module.exports = __webpack_public_path__ + "assets/img/partner8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner8.png
// module id = 1973
// module chunks = 0